<template>
  <div>
    <pdf :src="this.pdfFile" :page="1">
      <template slot="loading"> loading content here... </template>
    </pdf>
  </div>
</template>
<script>
import pdf from "pdfvuer";

export default {
  name: "TrompeLoeilPdf",
  components: {
    pdf,
  },
  data() {
    return {
      pdfFile: "/pdf/Schema commerciale carte.pdf",
    };
  },
};
</script>

<style lang="scss" scoped>
</style>
